import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorCreated: false,
  isCreated: false,
  isEdited: false,
  errorMessages: false,
  total: 0,
};
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TYPES.GET_THERMAL_CONTROL_MIXTURES_REQUEST:
    case TYPES.GET_THERMAL_CONTROL_MIXTURE_REQUEST:
    case TYPES.DELETE_THERMAL_CONTROL_MIXTURES_REQUEST:
    case TYPES.CREATE_THERMAL_CONTROL_MIXTURE_REQUEST:
    case TYPES.UPDATE_THERMAL_CONTROL_MIXTURE_REQUEST:
    case TYPES.FINALIZE_THERMAL_CONTROL_MIXTURE_REQUEST:
      return {
        ...state,
        fetching: true,
        isCreated: false,
        errorCreated: false,
      };

    case TYPES.GET_THERMAL_CONTROL_MIXTURES_ERROR:
    case TYPES.GET_THERMAL_CONTROL_MIXTURE_ERROR:
    case TYPES.DELETE_THERMAL_CONTROL_MIXTURES_ERROR:
    case TYPES.UPDATE_THERMAL_CONTROL_MIXTURE_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };

    case TYPES.CREATE_THERMAL_CONTROL_MIXTURE_ERROR: {
      return {
        ...state,
        errorCreated: payload,
        fetching: false,
      };
    }

    case TYPES.DELETE_THERMAL_CONTROL_MIXTURES_SUCCESS: {
      const list = state.list;
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list.splice(index, 1);
      else list.push(index);
      return {
        ...state,
        list,
        fetching: false,
        total: state.total - 1,
      };
    }

    case TYPES.CREATE_THERMAL_CONTROL_MIXTURE_SUCCESS: {
      return {
        ...state,
        list: [...state.list, payload],
        fetching: false,
        total: state.total + 1,
        isCreated: true,
      };
    }

    case TYPES.UPDATE_THERMAL_CONTROL_MIXTURE_SUCCESS:
    case TYPES.FINALIZE_THERMAL_CONTROL_MIXTURE_SUCCESS: {
      const list = state.list;
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list.splice(index, 1, payload);
      else list.push(payload);
      return {
        ...state,
        list,
        fetching: false,
        isEdited: true,
      };
    }

    case TYPES.GET_THERMAL_CONTROL_MIXTURE_SUCCESS: {
      const list = state.list;
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list.splice(index, 1, payload);
      else list.push(payload);
      return {
        ...state,
        list,
        fetching: false,
      };
    }

    case TYPES.GET_THERMAL_CONTROL_MIXTURES_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...payload.mixtures],
        fetching: false,
      };
    }

    case 'CLEAR_ERRORS': {
      return {
        ...state,
        errorCreated: false,
        errorMessages: false,
      };
    }

    case TYPES.CLEAR_CREATED_THERMAL_CONTROL_MIXTURE: {
      return { ...state, isCreated: false };
    }

    case TYPES.CLEAR_EDITED_THERMAL_CONTROL_MIXTURE: {
      return { ...state, isEdited: false };
    }

    default:
      return { ...state };
  }
};

export default reducer;
